import { ChangeEvent } from "react"

export default function CheckboxButton({
    action,
    label,
    isChecked,
    id,
}: {
    action: (e: ChangeEvent<HTMLInputElement>) => void,
    label: string,
    isChecked: boolean,
    id: string,
}) {
    return (
        <label htmlFor={id} className={`flex justify-between items-center gap-4 px-5 py-3 hover:cursor-pointer hover:border-primary hover:text-primary rounded-lg border transition-all ${isChecked ? 'border-primary text-primary font-medium bg-secondary' : 'border-outline text-default font-normal bg-white/[0.3]'}`}>
            <input id={id} onChange={action} checked={isChecked} type='checkbox' className='accent-primary' />
            <p className='text-[14px]'>{label}</p>
        </label>
    )
}